export * from "./update-dataset-value"
export * from "./with-props-validation"

/**
 * Defer importing a def view function until it's called
 *
 * There are some limitations in webpack around dynamic expressions, and so we
 * need to have the view base be a known path like `../`
 *
 * https://webpack.js.org/guides/migrating/#dynamic-expressions
 *
 * @param {String} path Path to view module (relative to entry root)
 */

function importDeferredView(path) {
  return async (el, props) => {
    const f = await import(`../${path}/index.ts`)
    return f.default(el, props)
  }
}

function importDeferredViewTsx(path) {
  return async (el, props) => {
    const f = await import(`../${path}/index.tsx`)
    return f.default(el, props)
  }
}

function importDeferredViewJs(path) {
  return async (el, props) => {
    const f = await import(`../${path}/index.js`)
    return f.default(el, props)
  }
}

export default {
  analyticsPageView: importDeferredView("analytics/page-view"),
  analyticsEvent: importDeferredView("analytics/event"),
  analyticsClickEvent: importDeferredView("analytics/click-event"),
  analyticsGlobalEvents: importDeferredView("analytics/global-events"),
  analyticsSegmentLoader: importDeferredView("analytics/segment-loader"),
  analyticsTrackLink: importDeferredView("analytics/track-link"),
  analyticsIdentifyAndTrackLink: importDeferredView(
    "analytics/identify-and-track-link",
  ),
  analyticsWistiaEvents: importDeferredView("analytics/wistia-events"),
  lazyLoad: importDeferredView("lazy-load"),
  masthead: importDeferredView("masthead"),
  mastheadSimplified: importDeferredView("masthead-simplified"),
  backgroundVideoControls: importDeferredView("background-video-controls"),
  companyValuesList: importDeferredView("company-values-list"),
  backgroundColorChangeOnScroll: importDeferredView(
    "background-color-change-on-scroll",
  ),
  salesToggle: importDeferredView("sales-toggle"),
  podcastSubscribeToggle: importDeferredView("podcast-subscribe-toggle"),
  basicCarousel: importDeferredView("basic-carousel"),
  testimonialCarousel: importDeferredView("testimonial-carousel"),
  tabs: importDeferredView("tabs"),
  productBlock: importDeferredView("product-block"),
  filters: importDeferredView("filters"),
  localizedDateTime: importDeferredView("localized-date-time"),
  toggle: importDeferredView("toggle"),
  logoSetRows: importDeferredView("logo-set-rows"),
  dropdown: importDeferredView("dropdown"),
  videoModal: importDeferredView("video-modal"),
  panelModal: importDeferredView("panel-modal"),
  dialogModal: importDeferredView("dialog-modal"),
  ribbon: importDeferredView("ribbon"),
  componentLibraryMasthead: importDeferredView("component-library-masthead"),
  articlesSearch: importDeferredViewTsx("articles-search"),
  careersListing: importDeferredViewTsx("careers-listing"),
  podcastCloseTranscript: importDeferredView("podcast-close-transcript"),
  stickyFilter: importDeferredView("sticky-filter"),
  tableOfContents: importDeferredView("table-of-contents"),
  adSpots: importDeferredView("ad-spots"),
  openSingleDetail: importDeferredView("open-single-detail"),
  openDetailsOnSearch: importDeferredView("open-details-on-search"),
  storyAnimationOnScroll: importDeferredView(
    "campaigns/research_guide_y22_q3/story-animation-on-scroll",
  ),
  mainAnimations: importDeferredView(
    "campaigns/research_guide_y22_q3/main-animations",
  ),
  companyDirections: importDeferredViewTsx(
    "campaigns/research_guide_y22_q3/company-directions",
  ),
  typeOfCompanyQuiz: importDeferredViewTsx(
    "campaigns/research_guide_y22_q3/type-of-company-quiz",
  ),
  packageFeatureToggle: importDeferredView("pricing/package-feature-toggle"),
  currencyToggle: importDeferredView("pricing/currency-toggle"),
  hsHiddenFieldsAssignment: importDeferredView(
    "pricing/hs-hidden-fields-assignment",
  ),
  hubspotForms: importDeferredView("hubspot-forms"),
  partnersMarketplaceListing: importDeferredViewTsx(
    "partners-marketplace/partners-listing",
  ),
  partnersHiddenFormFields: importDeferredView(
    "partners-marketplace/partners-form",
  ),
  progressBarAnimation: importDeferredView(
    "campaigns/ex-map/progress-bar-animation",
  ),
  exMapPills: importDeferredView("campaigns/ex-map/pills"),
  exMapCardFlip: importDeferredView("campaigns/ex-map/card-flip"),
  exMapAnimations: importDeferredView("campaigns/ex-map/ex-map-animations"),
  cultureFirstGlobal2023: importDeferredView(
    "campaigns/culture-first-global/2023",
  ),
  textSnippetShare: importDeferredView("text-snippet-share"),
  blogSlideup: importDeferredView("blog-slideup"),
  survey: importDeferredViewJs("campaigns/hrforhr/survey"),
  copyToClipboard: importDeferredView("copy-to-clipboard"),
  ropiCalculator: importDeferredViewTsx("ropi-calculator"),
}
